import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/diveIN/step2';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Annulation } from '../../models/Annulation';

@Component({
	selector: 'app-step2',
	templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {

	private LOG: LogService = new LogService(Step2Component);

	@Input() annulation: Annulation;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() uid = '';

	public step2 = new Step2();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


	ngOnInit(): void {
	}

	public getUid() {
		return this.uid;
	}

}
